import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "performance_optimization_colored",
  "use": "performance_optimization_colored-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 17 16\" id=\"performance_optimization_colored\"><path fill=\"#BBFFD6\" d=\"M13.153 13.97a6.934 6.934 0 1 0-9.806 0l1.324-1.324a5.062 5.062 0 1 1 7.158 0z\" /><path fill=\"#00EF5F\" d=\"M16.108 10.566a.596.596 0 0 1-.631.482l-6.307-.492A2.5 2.5 0 1 1 10.232 8.2l5.466 1.686c.29.09.467.383.41.68\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol